import { get } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import OTIcon from '../../tag/OTIcon';

('use strict');

const ReservationInfo = ({ data }) => {
  if (get(data, 'key', null) === null) return null;

  return data.meta.map((meta) => (
    <div key={data.key + '.' + meta} className={'reservation-info'}>
      <OTIcon
        config={{ type: 'fa', name: 'icon-info-sign' }}
        style={{ position: 'absolute', left: 0, top: '10px' }}
      />
      <div
        style={{
          marginLeft: '24px',
          display: 'inline-block',
          marginTop: '10px',
          marginBottom: '10px',
        }}
      >
        <FormattedMessage
          id={data.key + '.' + meta}
          values={{
            kuulokeskusLink: (chunks) => (
              <a
                className="reservation-info-link"
                href="https://www.pirha.fi/fi/toimipisteet/toimipistehakemisto/kuulokeskus-tays-keskussairaala"
                target="_blank"
              >
                {chunks}
              </a>
            ),
            br: <br />,
            fontWeightNormal: (chunks) => (
              <span style={{ fontWeight: 'normal' }}>{chunks}</span>
            ),
          }}
        />
      </div>
    </div>
  ));
};

export default ReservationInfo;
